<style lang="less">
.Links{
	.title{
		height: 36px;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		padding: 0 16px;
		background: #f2f2f2;
		color: #999;
		font-size: 12px;
		font-weight: 400;
	}
	.item{
		padding: 0 16px;
		overflow: hidden;
		a{
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			height: 64px;
			border-bottom: 1px solid #f2f2f2;
			color: #000;
			font-size: 16px;
			padding: 0 8px;
			font-weight: 400;
		}
	}
}
</style>

<template>
	<!-- Main Links -->
	<section class="Links">
		<div class="title">
			<h3>开通余额+</h3>
		</div>
		<div class="item">
			<router-link to="/canvas">char</router-link>
			<router-link to="/guide">引导页</router-link>
			<router-link to="/support/bank">银行卡列表</router-link>
			<router-link to="/acctplus/detail">余额+详情</router-link>
			<router-link to="/acctplus">余额+ </router-link>
			<router-link to="/acctplus/info">余额+ 完善信息</router-link>
			<router-link to="/acctplus/identity">余额+ 验证身份</router-link>
			<router-link to="/acctplus/bank">余额+ 绑定银行卡</router-link>
			<router-link to="/account">余额</router-link>
			<router-link to="/account/charge">余额转入</router-link>
			<router-link to="/account/takeout">余额取出</router-link>
			<a href="https://cash.meizu.com/#/account/result?pay_order_id=1806001170276778404773888">余额+转入成功</a>
			<a href="https://cash.meizu.com/#/account/result?pay_order_id=1806000170303851848564736">余额+取出成功</a>
			<a href="https://cash.meizu.com/#/account/result?pay_order_id=1806000170497874697682944">余额+普通取出成功</a>
			<router-link to="/order">账单</router-link>
			<router-link to="/order/detail?id=1806001170278256645275648">余额+转入账单详情</router-link>
			<router-link to="/order/detail?id=1806000160099152394485760">余额+转出账单详情</router-link>
			<a href="https://cash.meizu.com/#/account/result?pay_order_id=1806000170622480477782016">余额取出成功</a>
			<a href="https://cash.meizu.com/#/account/result?pay_order_id=1806000170601889028833280">余额转入成功</a>
			<router-link to="/identity">完善信息</router-link>
			<router-link to="/verify">验证身份</router-link>
			<router-link to="/verify/result">结果反馈</router-link>
			<router-link to="/evaluating">风险等级测评</router-link>
			<router-link to="/evaluating/result">风险等级测评结果</router-link>
			<router-link to="https://cash.meizu.com/#/account/result?pay_order_id=1805000130080638158176256">余额转出结果</router-link>
		</div>
	</section>
</template>

<script>
	export default {
		data: function () {
			return {
			};
		},
		components: {
		},
		mounted: function () {
		},
		methods: {

		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Links.vue